export default __webpack_public_path__ + "static/media/headerf.ce70aee2.jpg";